import { all, takeEvery, take, call, put, fork } from 'redux-saga/effects';
import { uploadDocument, uploadDocumentProgress, uploadDocumentSuccess, uploadDocumentFailure, cancelDocumentUpload } from '../actions';
import { createUploadChannel } from './base';
function* createDocumentUploadChannel(file, deviationId, documentType) {
    const url = 'deviation/submit/upload/document';
    const formData = new FormData();
    formData.append('document_file', file);
    formData.append('deviationid', `${deviationId}`);
    formData.append('type', documentType);
    return yield call(createUploadChannel, url, formData, 'document');
}
function* uploadDocumentHandler({ payload: { file, deviationId, documentType, onSuccess } }) {
    const channel = yield call(createDocumentUploadChannel, file, deviationId, documentType);
    // If a cancel action for this document type is fired we close the channel
    yield fork(function*() {
        yield take((action)=>action.type === cancelDocumentUpload.toString() && action.payload.documentType === documentType);
        channel.close();
    });
    while(true){
        const { progress = 0, error, success, response } = yield take(channel);
        if (error) {
            yield put(uploadDocumentFailure(documentType, error));
            return;
        }
        if (success) {
            const documentUrl = documentType === 'narf' ? response.narfDocument : response.sprfDocument;
            yield put(uploadDocumentSuccess(documentType, documentUrl));
            yield call(onSuccess, documentUrl);
            return;
        }
        yield put(uploadDocumentProgress(documentType, progress));
    }
}
export default function* saga() {
    yield all([
        takeEvery(uploadDocument, uploadDocumentHandler)
    ]);
}

//# sourceMappingURL=legalDocuments.js.map